import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { WidgetService } from '../../services/widget.service';
import { CardComponent } from '../../shared/components/card/card.component';
import { GenericService } from '../../services/generic.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-recovery-password',
  standalone: true,
  imports: [CardComponent,CommonModule],
  templateUrl: './recovery-password.component.html',
  styleUrl: './recovery-password.component.scss'
})
export class RecoveryPasswordComponent implements OnInit {
  widget: any;
  step: any = null;
  currentStep: any;
  journey ='';
  otpValue = ''
  otp: string[] = Array(8).fill('');
  @ViewChildren('otpBox') boxes!: QueryList<ElementRef<HTMLInputElement>>;
  otpCallback: any;

  
  constructor(
      private widgetSrv: WidgetService,
      private genericService: GenericService,
      private cookieService: CookieService,
      
    ) { 
      console.log('this.otp')
      console.log(this.otp)
    }
  ngOnInit(): void {
    this.showWidget();
   
    const observer = new MutationObserver(()=> {
      const parentBackButton = document.querySelector('#genericStepForm') as HTMLElement
      if(parentBackButton) {
        console.log('el parentBackButton fue corregido')
        const pBackButton = parentBackButton.querySelector('.tw_my-4') as HTMLElement
        console.log(pBackButton)
        if(pBackButton) {
          console.log('el pBackButton fue corregido')
          const backButton = pBackButton.querySelector('button') as HTMLElement

            console.log('en el otp')
            const header = document.querySelector('#genericStepHeader') as HTMLElement
            const inp = document.querySelector('#genericStepForm div') as HTMLElement
           
            header.style.display = "none"
            inp.style.display = "none"
           
            
          
          if(backButton) {
            console.log('el BackButton fue corregido')
    
            backButton.style.display = 'none'


            observer.disconnect()
          }
            else {
              console.log('no se encontro el BackButton')
            }
        }
          else {
            const inp = document.querySelector('#genericStepForm div') as HTMLElement
           
            inp.style.display = "none"
            console.log('no se encontro el pBackButton')
          }
      }
        else {
          console.log('no se encontro el parentBackButton')
        }
        
      
    })  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
    /* setTimeout(() => {
      if(this.step != "ValidatedCreatePasswordCallback") this.genericService.setPlaceholder('#IDToken1', 'Username');
      const parentBackButton = document.querySelector('#genericStepForm') as HTMLElement
      if(parentBackButton) {
        console.log('el parentBackButton fue corregido')
        const pBackButton = parentBackButton.querySelector('.tw_my-4') as HTMLElement
        console.log(pBackButton)
        if(pBackButton) {
          console.log('el pBackButton fue corregido')
          const backButton = pBackButton.querySelector('button') as HTMLElement
          console.log(backButton)
          if(backButton) {
            console.log('el BackButton fue corregido')
    
            backButton.style.display = 'none'
          }
            else {
              console.log('no se encontro el BackButton')
            }
        }
          else {
            console.log('no se encontro el pBackButton')
          }
      }
        else {
          console.log('no se encontro el parentBackButton')
        }
        
      
    },400);  */
  }
  showWidget() {
    //this.widget = this.widgetSrv.setWidget('Spark_ForgotPassword');
   this.widget = this.widgetSrv.setWidget('Spark_ForgotPassword');
   if(this.widget) {
      this.widget
      .subscribe((event:any) => {
        this.cleanMessage()
        console.log('whole journey')
        console.log(event.journey)
        if(event.journey.completed){
          console.log('evento completo')
          console.log('navegando a login')
          //this.router.navigate(['/login'])
          const url = this.cookieService.get('urlWithParams');
          console.log(url)
          window.open(url, '_self');
          }
        /* Run anything you want */
        if(event.journey?.step?.type == 'Step') {
          console.log(event.journey?.metadata?.step?.platform?.stageName)

          this.step = event.journey.step?.payload?.callbacks.map((val:any)=>val.type).join("-")
          console.log('this.step')
          console.log(this.step)
          console.log(event.journey?.metadata?.step)
          const otpCallback = event.journey.step.callbacks?.find(
            (cb:any) => cb.payload?.input?.[0]?.name === 'IDToken1'
          )
          if(otpCallback) {
            this.otpCallback = otpCallback
          }
          if(this.step === "ValidatedCreatePasswordCallback") {
            setTimeout(() => {
              this.genericService.setPlaceholder('#IDToken1-confirm', 'Confirm Password');
              this.genericService.setPlaceholder('#IDToken1', 'Password');
              
              const parent = document.getElementById('genericStepHeader')
              const p = document.createElement('p')
              p.textContent = 'Please enter your new password'; 
              if(parent && parent.firstChild) {
                parent.replaceChild(p, parent.firstChild)}

            },1000);  
          } 
        
        }
      });      
    } 
  }
  cleanMessage() {
    const parent = document.getElementById('genericStepHeader')
      const p = document.createElement('p')
      p.textContent = ''; 
      if(parent && parent.firstChild) parent.replaceChild(p, parent.firstChild)
  }
 onInput(event: Event, index: number){
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if(value.length === 1 && index < this.boxes.length -1 ) {
      this.boxes.get(index + 1)?.nativeElement.focus()
    }
    this.updateOtpValue()
  }
  updateOtpValue() {
    const otpInput = document.getElementById('IDToken1') as HTMLInputElement
    const otpValue = this.boxes.toArray().map((e)=>e.nativeElement.value).join('');
    console.log('otpValue')
    console.log(otpValue)
    console.log(otpInput)
    console.log(this.otpCallback.payload)
    if(otpInput) {
      otpInput.focus();
      otpInput.value =  otpValue
      this.otpValue =  otpValue
      this.otpCallback.payload.input[0].value = this.otpValue
      otpInput.dispatchEvent(new Event('input', { bubbles: true}))
      otpInput.blur();
    }
 
  
  }
  onClickContinue() {
      this.otpCallback.payload.input[0].value = this.otpValue
      this.widget.next(this.currentStep)
      
  }
  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement
    if(event.key === 'Backspace' && !input.value && index > 0) {
      this.boxes.get(index - 1)?.nativeElement.focus()
    }
  }
}
